import Vue from 'vue';

export default {
  state: {
    age_groups: [],
  },
  getters: {
    age_groups(state) {
      return state.age_groups;
    },
    // eslint-disable-next-line
    age_group: state => (id) => {
      return state.age_groups.find(type => type.id === id) || {};
    },
  },
  mutations: {
    SET_AGE_GROUPS(state, payload) {
      state.age_groups = payload;
    },
  },
  actions: {
    GET_AGE_GROUPS(context) {
      return Vue.axios.get('filters/age_groups').then((response) => {
        context.commit('SET_AGE_GROUPS', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/age_groups.js